import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const bindMiddleware = middlewares => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('@redux-devtools/extension');
    return composeWithDevTools(applyMiddleware(...middlewares));
  }

  return applyMiddleware(...middlewares);
};

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, {}, bindMiddleware([sagaMiddleware]));
sagaMiddleware.run(rootSaga);

export default store;
